const enumValue = description => Object.freeze({
    toString: () => description
});

export const NAME = enumValue("NAME");
export const TYPE = enumValue("TYPE");
export const NO_SORT = enumValue('');
